import { gql } from 'graphql-request'
import { fragmentBlocksQuery } from '../fragments/blocks'

export const SinglePageQuery = gql`
  query SinglePage(
    $slug: Page_slug_operator,
    $isPreview: Boolean! = false,
    $statuses: [Page__status_Input] = [published],
    $locale: LocaleInputType!
  ) {
    Pages(
        draft: $isPreview,
        locale: $locale,
        where: {
          AND: [
            { slug: $slug }
            { _status: { in: $statuses } }
          ]
        }
    ) {
      docs {
        title
        id
        content ${fragmentBlocksQuery}
      }
      totalDocs
    }
  }
`
